import { Component} from '@angular/core';
import { ApiService } from '../api.service';
import { HandlerService } from '../handler.service';
import { PdfService } from '../pdf.service';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { Router } from '@angular/router';
import { PaymentService } from '../payment.service';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../auth.service';
import { LocationService } from '../location.service';

@Component({
  selector: 'app-manage-orgs',
  templateUrl: './manage-orgs.component.html',
  styleUrls: ['./manage-orgs.component.scss'],
})
export class ManageOrgsComponent {

  loader:boolean = false;
  id;
  search:any=[];
  cloneUsers;
  contactNbrMob;
  filterLength;
  active: boolean = false;
  dupUsers:any;
  orgs : any=[];    
  orgName;
  orgId;
  header;
  
  constructor(private service: ApiService,
    public handler: HandlerService,
    public pdf: PdfService,
    public bottomSheet: MatBottomSheet,
    public router: Router,
    public payment:PaymentService,
    public translate: TranslateService,
    public auth: AuthService,  public location: LocationService) { }

    ionViewWillEnter(){  
      this.id =localStorage.getItem('organizationId');   
      this.getOrgs();
      
      }
    
  ionViewWillLeave(){
    this.search = "";
  }

  refreshData(event){
    this.loader = true; 
    this.ionViewWillEnter();
    setTimeout(() => {
      event.target.complete();
    }, 1000);
  }

  getOrgs(){
    this.loader=true;
    this.service.getOrg().subscribe((res:any)=>{
      this.orgs=res;     
      this.orgs = this.orgs.filter(res=> { return res.approvalStatus == 2 && res.activeInd==true})   
      this.loader=false;
    })
  }

    booking1(id){
      this.router.navigate(['manageRequest/', +id])
  }

  select(id){
    this.router.navigate(['profile-org/',+id])
  }

  clear(){
    this.search="";
  }

  ngDoCheck(): void {
    this.filterLength = sessionStorage.getItem('len')
  
  }

  }


